import styled from "@emotion/styled";

export const globalWidth = "1024px";

export const fonts = {
  SpoqaBold: "SpoqaHanSansNeo-Bold",
  SpoqaMedium: "SpoqaHanSansNeo-Medium",
  SpoqaRegular: "SpoqaHanSansNeo-Regular",
  SpoqaLight: "SpoqaHanSansNeo-Light",
  SpoqaThin: "SpoqaHanSansNeo-Thin",
  SuiteBold: "SUITE-Bold",
  SuiteRegular: "SUITE-Regular",
};

export const colors = {
  Primary10: "#CBF1FD",
  Primary20: "#97DEFC",
  Primary30: "#63C3F7",
  Primary40: "#3CA7F0",
  Primary50: "#007DE7",
  Primary60: "#0060C6",
  Primary70: "#0048A6",
  Primary80: "#003285",
  Primary90: "#00246E",

  Secondary10: "#CBFEF2",
  Secondary20: "#98FDEF",
  Secondary30: "#64FBF1",
  Secondary40: "#3DF3F7",
  Secondary50: "#00DAF2",
  Secondary60: "#00AAD0",
  Secondary70: "#0080AE",
  Secondary80: "#005C8C",
  Secondary90: "#004374",

  BG20: "#FAFAFA",
  BG30: "#EFEFEF",
  BG40: "#DFDFDF",
  BG50: "#F6FAFF",

  Gray10: "#F3F3F3",
  Gray30: "#D9D9D9",
  Gray50: "#AFAFAF",
  Gray70: "#636363",
  Gray90: "#333333",

  White: "#FFFFFF",
  Black: "#212121",

  Success10: "#F3FFF1",
  Success20: "#1CCA00",

  Warning10: "#FFF6EB",
  Warning20: "#FF9921",

  Error10: "#FFF3F3",
  Error20: "#FF0000",
};

export const Title1 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 24px;
  line-height: 34px;
  letter-spacing: -0.5px;
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Title2 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.5px;
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Title3 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.5px;
  font-weight: 400;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Body1 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.5px;
  font-weight: 400;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Body2 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.5px;
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const SubBody = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.5px;
  font-weight: 400;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const SubBodyBold = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.5px;
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const SubTitle = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -0.5px;
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Caption1 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.5px;
  font-weight: 400;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;

export const Caption2 = styled.div<{
  color?: string;
  align?: "auto" | "left" | "right" | "center" | "justify";
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
}>`
  font-size: 10px;
  line-height: 14px;
  letter-spacing: -0.5px;
  font-weight: 400;
  color: ${(props) => (props.color ? props.color : colors.Gray90)};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : 0)};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : 0};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : 0};
  text-align: ${(props) => (props.align ? props.align : "center")};
`;
